export default __webpack_public_path__ + "static/media/concern-icon.ea231b63.svg";